export const ON_POP_STATE = 'on-pop-state';
const onPopState = historyState => ({ type: ON_POP_STATE, payload: { historyState } });
export default onPopState;
